import { useMemo, useState, useEffect, useRef } from "react";
import FilterIcon from "../IconsCode/FilterIcon";

const filterOptions = [
    { key: "accessOwnBrand", label: "دسترسی برند خود" },
    { key: "accessOtherBrands", label: "دسترسی برند دیگر" },
];

function FilterBrand({ searchTerm = "", onSearchChange, filters = {}, onFilterChange }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    const filterLabel = useMemo(() => {
        const active = filterOptions
            .filter((option) => filters[option.key])
            .map((option) => option.label);
        if (active.length === 0) return "فیلتر دسترسی";
        return active.join("، ");
    }, [filters]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    const toggleFilter = (key) => {
        onFilterChange?.({
            ...filters,
            [key]: !filters[key],
        });
    };

    const clearFilters = () => {
        onFilterChange?.({ accessOwnBrand: false, accessOtherBrands: false });
    };

    return (
        <div className="flex flex-row-reverse items-center">
            <input
                type="text"
                placeholder="جستجو بر اساس نام یا دامنه"
                value={searchTerm}
                onChange={(e) => onSearchChange?.(e.target.value)}
                className="w-72 h-12 md:w-96 p-2 rounded-r-lg border border-slate-300 bg-primary-100 text-sm text-right outline-none"
            />

            <div ref={containerRef} className="relative">
                <button
                    type="button"
                    onClick={() => setOpen((prev) => !prev)}
                    className="flex flex-row-reverse items-center justify-between gap-2 bg-primary-100 border border-slate-300 border-r-none rounded-l-lg py-2 px-3 text-sm text-right w-48 h-12"
                >
                    <span className="truncate">{filterLabel}</span>
                    <FilterIcon />
                </button>

                {open && (
                    <div className="absolute top-12 right-0 z-50 w-56 rounded-lg border border-gray-200 bg-white shadow-lg p-3">
                        <div className="flex flex-col gap-2">
                            {filterOptions.map((option) => (
                                <label
                                    key={option.key}
                                    className="flex flex-row-reverse items-center justify-between gap-2 rounded-lg px-3 py-2 cursor-pointer hover:bg-primary-50"
                                >
                                    <span className="text-sm text-right">{option.label}</span>
                                    <input
                                        type="checkbox"
                                        checked={Boolean(filters[option.key])}
                                        onChange={() => toggleFilter(option.key)}
                                        className="w-4 h-4 cursor-pointer"
                                    />
                                </label>
                            ))}
                            <button
                                type="button"
                                onClick={clearFilters}
                                className="mt-2 w-full rounded-lg border border-primary-200 bg-primary-50 py-2 text-sm text-primary-700"
                            >
                                پاک کردن فیلترها
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default FilterBrand;
